export default {"src":"/_next/static/media/manab.16248de1.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};